const ACCOUNT_DOMAIN = process.env.VUE_APP_AUTH_ENDPOINT;

export const HOST = {
  ACCOUNT_DOMAIN,
};
